import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    email: String,
    password: String
  }

  fillAndSubmit(event: Event) {
    console.log("Debug Login: Triggered", this.emailValue)
    event.preventDefault()
    
    const form = this.element.closest("form")
    if (!form) return

    const emailInput = form.querySelector('input[type="email"]') as HTMLInputElement
    const passwordInput = form.querySelector('input[type="password"]') as HTMLInputElement

    if (emailInput) {
      emailInput.value = this.emailValue
      emailInput.dispatchEvent(new Event("input", { bubbles: true }))
      emailInput.dispatchEvent(new Event("change", { bubbles: true }))
    }

    if (passwordInput) {
      passwordInput.value = this.passwordValue
      passwordInput.dispatchEvent(new Event("input", { bubbles: true }))
      passwordInput.dispatchEvent(new Event("change", { bubbles: true }))
    }

    // Small delay to ensure any validation or masking is processed
    setTimeout(() => {
      console.log("Debug Login: Submitting form")
      form.submit()
    }, 50)
  }
}
